import { withRetry, createError } from '../../../utils/requests/withRetry.js';

const {
  VITE_CONTEXT_ENGINE_CAMPAIGNS_ENDPOINT: CAMPAIGN_ENDPOINT,
  VITE_CONTEXT_ENGINE_OFFERS_WIDGET_ENDPOINT: OFFERS_ENDPOINT
} = import.meta.env;

const fetchCampaignError = async res => {
  const noContent = res.status === 204;
  if (res.ok && !noContent) return;

  throw createError(
    `HTTP ${res.status} ${res.statusText}`,
    res.status,
    res.statusText,
    noContent ? 'No content' : await res.text()
  );
};

/**
 * Fetches offers from CMS.
 *
 * @param {Object} [params={}] The url search parameters in a key-value pair data structure.
 * @returns {Promise} Returns a promise that resolves to the offers data or rejects if request fails for any reason.
 */
const fetchOffers = async (params = {}) => {
  const makeRequest = async attempt => {
    const urlParams = new URLSearchParams(params).toString();
    const headers = { 'Content-Type': 'application/json' };

    if (attempt > 0) headers['x-retry'] = attempt.toString();

    const res = await fetch(`${OFFERS_ENDPOINT}?${urlParams}`, {
      method: 'GET',
      headers
    });

    await fetchCampaignError(res);
    return await res.json();
  };

  return withRetry(makeRequest);
};

const fetchWidget = async (slotId, overrideUrl) => {
  const makeRequest = async attempt => {
    const hostRaw = {
      referer: overrideUrl || window.location.href,
      slot: slotId || ''
    };
    const host = window.btoa(JSON.stringify(hostRaw));
    const headers = { 'Content-Type': 'application/json' };

    if (attempt > 0) headers['x-retry'] = attempt.toString();

    const res = await fetch(`${CAMPAIGN_ENDPOINT}?json&host=${host}`, {
      method: 'POST',
      headers
    });

    await fetchCampaignError(res);
    return await res.json();
  };

  return withRetry(makeRequest);
};

export const http = {
  fetchOffers,
  fetchWidget
};
